import "./Content.css";
// import {Iocube} from "./react-icons/"
import { Link } from "react-router-dom";
import { GiCube } from "react-icons/gi";

const Content = () => {
  return (
    <div className=" maincontentTop">
      <div className=" headingtopdiv">
        <div className=" headingtopcontent">
          <span>
            <GiCube></GiCube>
          </span>
          <h2 className="text-5xl my-2 font-medium">The best place to build, test, design and develope your code.</h2>
        </div>
        <div className="paradiv ">
          <p>
            Featherpad Editor is a social development environment for front-end designers
            and developers. Build and deploy a website, show off your work,
            build test cases to learn and debug, and find inspiration.
          </p>
          {/* <Link to="/webeditor">webeditor</Link> */}
          <Link to="/login">
            {" "}
            <button className="contentbuttons">Signup For Free</button>
          </Link>
        </div>
      </div>

      <div className="div outerdots">
        <div className="div camera -x">
          <div className="div camera -y">
            <div className="div camera -z">
              <div className="div sea">
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div wave">
                  <div className="div counter -z">
                    <div className="div counter -y">
                      <div className="div counter -x">
                        <div className="div graphic"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
